import {Observable, throwError} from 'rxjs';
import { environment } from '../../../environments/environment';
import { Injectable} from '@angular/core';
import { CommonService } from "./common.service";
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import {catchError, map} from "rxjs/operators";


@Injectable()
export class HttpClientService {
  authError: any;
  idempotencyKey:any;
  constructor(private http: HttpClient, private commonService: CommonService, private router: Router) { this.idempotencyKey =this.generateIdempotencyKey();};

  getThirdParty(url, param?: string, headers?: any): Observable<any> {
    if (typeof param === 'object') param = this.commonService.stringParams(param);
    if (param != null) param = "?" + param;
    else param = "";

    return this.http.get(url + param, this.jwt(headers))
      .pipe((map((res:any) => { return res || {}; })),
        catchError((e:HttpErrorResponse) => this.handleError(e)));
  };

  get(url, param?: any, customHeader?: any): Observable<any> {
    if (typeof param === 'object') param = this.commonService.stringParams(param);
    if (param != null) param = "?" + param;
    else param = "";

    return this.http.get(environment.API_ENDPOINT + url + param, this.jwt(customHeader))
      .pipe((map((res:any) => { return res || {}; })),
        catchError((e:HttpErrorResponse) => this.handleError(e)));
  };

  post(url, param?: any, customHeader?: any): any {
    return this.http.post(environment.API_ENDPOINT + url, param, this.jwt(customHeader))
      .pipe((map((res:any) => { this.handleSuccess(); return res})),
        catchError((e:HttpErrorResponse) => this.handleError(e)));
  };

  put(url, param?: any, customHeader?: any): any {
    return this.http.put(environment.API_ENDPOINT + url, param, this.jwt(customHeader))
      .pipe((map((res:any) => { this.handleSuccess(); return res})),
        catchError((e:HttpErrorResponse) => this.handleError(e)));

  };
  postFile(url, formData?: any, customHeader?: any): any {
    return this.http.post(environment.API_ENDPOINT + url, formData, this.jwt(customHeader))
      .pipe((map((res:any) => { this.handleSuccess(); return res})),
        catchError((e:HttpErrorResponse) => this.handleError(e)));
  };
  postWithParams(url, params?: any, customHeader?: any): any {
    return this.http.post(environment.API_ENDPOINT + url, null, this.jwt(customHeader, params))
      .pipe((map((res:any) => { this.handleSuccess(); return res})),
        catchError((e:HttpErrorResponse) => this.handleError(e)));
  }

  downloadFile(apiUrl: string, contentType): Observable<Object[]> {
    return Observable.create(observer => {

        let xhr = new XMLHttpRequest();
        xhr.open('GET', `${environment.API_ENDPOINT}/${apiUrl}`, true);
        xhr.setRequestHeader('Auth-Token',this.commonService.getToken());
        xhr.setRequestHeader('Accept',"application/pdf");
        xhr.responseType = 'blob';

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {

                    let blob = new Blob([xhr.response], { type:  contentType});
                    observer.next(blob);
                    observer.complete();
                } else {
                    observer.error(xhr.response);
                }
            }
        };
        xhr.send();

    });
}
  private jwt(customHeaders?: any, params?: any) {

    let headers = new HttpHeaders();
    headers.append('IdempotencyKey', this.idempotencyKey);
    if (customHeaders != null) {
      for (let k in customHeaders)
        headers.append(k, customHeaders[k]);
    }
    if (this.commonService.getToken() != null) {
      if (!headers.has(this.commonService.authToken))
        headers.append(this.commonService.authToken, this.commonService.getToken());
    }

    return { headers: headers, params: params };

  }


  addToOnlineOrder() {
    let headers: HttpHeaders = new HttpHeaders();
    headers.append("Authorization", "Basic " + btoa("dtr:dtr18Feb2015"));
    headers.append('IdempotencyKey', this.idempotencyKey);
    //headers.append("Content-Type", "multi-part/fo");
    let formdata = new FormData();
    formdata.append('user_id', this.commonService.getData().userId);
    formdata.append('rawhtml', 'sample html');
    formdata.append('order_url', window.location.href);
    formdata.append('store_id', '4');
    return this.http.post(environment.ONLINE_ORDER_ENDPOINT, formdata, { headers: headers })
  }

  private handleError(error: HttpErrorResponse) {
    this.authError = error;
    if (this.authError.status === 403) {
      this.commonService.removeAllStorage();
      try {
        eval("HTMLOUT.logout()");
      } catch (w) { }
      this.router.navigate(["/"]);
    }
    return throwError(new Error(error.message))
    // return Observable.throw(error.error);
  }

  private generateIdempotencyKey(): string {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }

  private handleSuccess(): void {
    this.idempotencyKey = this.generateIdempotencyKey();
  }
}
